import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSpotlight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSpotlight"><Path fillRule="evenodd" clipRule="evenodd" d="M22.0586 9L19.0586 12L22.0586 15L14.998 22.0605L11.998 19.0605L8.99805 22.0605L1.9375 15L4.9375 12L1.9375 9L8.99805 1.93945L11.998 4.93945L14.998 1.93945L22.0586 9ZM7.05859 12L11.998 16.9395L16.9375 12L11.998 7.06055L7.05859 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSpotlight;
